import { Card, Typography, Box } from '@mui/material'
import { MakeAmountStyle } from '@utils/dataHelper'
import StatusBadge from '../StatusBadge'
import ProgressBar from '../ProgressBar'
import StakeItem from '../StakeItem'
import './DealItem.scss'

const DealItem = (props) => {
  const {
    logo,
    name,
    desc,
    status,
    myStakes,
    stakeAmount,
    stakeCount,
    presaleAmount,
    hoursLeft
  } = props.data;

  const _desc = desc.replace(/(<([^>]+)>)/gi, "")

  return (
    <Card
      variant="outlined"
      className="dealItem"
    >
      <StatusBadge status={status} hoursLeft={hoursLeft} />
      <Box
        sx={{ display: "flex", alignItems: "top", justifyContent: "space-between", mt: 3, mb: 2 }}
      >
        <Box>
          <Typography
            variant="h2"
          >
            {name}
          </Typography>
          <Typography
            sx={{ mt: 0.5 }}
          >
            {_desc.length < 110 ? _desc : _desc.slice(0, 110) + ' ...'}
          </Typography>
        </Box>
        <Box className="deal-logo text-right">
          <img src={logo} alt="deal logo" />
        </Box>
      </Box>
      {status < 5 && (
        <ProgressBar
          preSale={presaleAmount}
          stakes={stakeCount}
          staked={stakeAmount}
          padding="md"
        />
      )}
      {
        myStakes.map((stake, index) => {
          if (index > 1) return true;

          return (
            <StakeItem
              key={index}
              position={stake.position.toString()}
              status={status}
              amount={MakeAmountStyle(Number(stake.amount) + Number(stake.restAmount), true)}
              bonus={stake.bonus}
              bonusHide={true}
              hide={false}
              isOwn={true}
            />
          )
        })
      }
    </Card>
  )
}

export default DealItem